import { useState as e, useMemo as o, useCallback as t } from "react";
import { useDropzone as i } from "react-dropzone";
import { useNotifications as s } from "../../../../common/providers/NotificationProvider/hooks/useNotifications.js";
import { MAX_FILES as r, MAX_FILE_SIZE as p } from "../constants.js";
const n = { "application/pdf": [], "image/png": [], "image/jpeg": [] }, c = ({ onRemoveFile: c2, selectedFiles: l, setSelectedFiles: m, accept: a, maxFiles: d }) => {
  const [g, F] = e([]), { push: f } = s(), u = d || r, x = o(() => u - l.length, [l.length, u]), h = t((e2, o2) => {
    e2.length > x ? f({ message: [`Максимальна дозволена кількість файлів ${u}`], type: "danger", options: { duration: 3e3 } }) : (m([...l, ...e2]), F(o2));
  }, [x, f, l, m, u]), { getRootProps: j, getInputProps: v } = i({ accept: a || n, maxSize: p, onDrop: h }), P = t((e2) => {
    c2 == null ? void 0 : c2(e2);
    const o2 = [...l];
    o2.splice(o2.indexOf(e2), 1), m(o2);
  }, [l, c2, m]), R = t((e2) => {
    const o2 = [...g];
    o2.splice(o2.indexOf(e2), 1), F(o2);
  }, [g]);
  return { removeFile: P, getRootProps: j, getInputProps: v, selectedFiles: l, setSelectedFiles: m, rejectedFiles: g, removeRejectedFile: R, maxFiles: x };
};
export {
  c as useCustomDropzone
};
//# sourceMappingURL=useCustomDropzone.js.map
